import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  button: css`
    position: absolute;
    inset-block-start: -56px;
    inset-inline-start: 16px;
    z-index: 1000;
    inline-size: fit-content;
  `,
}
